export default "__VITE_ASSET__vhwiSI_s__"